import { resolveMileageRate } from '../../year-rates';

export const getDefaultMileageRate = (): number => resolveMileageRate(null, new Date());
